export const iconFlag = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="62.503"
      height="70.761"
      viewBox="0 0 62.503 70.761"
    >
      <g
        id="Group_1"
        data-name="Group 1"
        transform="translate(-805.824 -609.99)"
      >
        <path
          id="Path_1"
          data-name="Path 1"
          d="M2.662,19.993l27.228,47.6a1.28,1.28,0,0,0,2.22.01L59.652,20.266a1.285,1.285,0,0,0-1.111-1.919L3.786,18.091a1.279,1.279,0,0,0-1.126,1.9Z"
          transform="translate(806 610)"
          fill="none"
          stroke="#37acbb"
          stroke-miterlimit="10"
          stroke-width="5"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M59.658,50.75,32.43,3.149a1.28,1.28,0,0,0-2.22-.01L2.667,50.477A1.285,1.285,0,0,0,3.778,52.4l54.756.256a1.281,1.281,0,0,0,1.126-1.9Z"
          transform="translate(806 610)"
          fill="none"
          stroke="#37acbb"
          stroke-miterlimit="10"
          stroke-width="5"
        />
      </g>
    </svg>
  );
};

export const iconQustionsMark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 74.967 77.451"
    >
      <g
        id="Group_3"
        data-name="Group 3"
        transform="translate(-1043.505 -533.838)"
      >
        <path
          id="Path_18"
          data-name="Path 18"
          d="M285.712,88.134a20.878,20.878,0,0,1,26.066,28.819.2.2,0,0,0-.009.157l3.677,10.195a.207.207,0,0,1-.265.265l-9.244-3.316a.2.2,0,0,0-.191.03,20.867,20.867,0,0,1-29.831-4.722,21.715,21.715,0,0,1-3.7-12.4v-.85"
          transform="translate(802 469)"
          fill="none"
          stroke="#37acbb"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_19"
          data-name="Path 19"
          d="M285.749,86.779A20.878,20.878,0,0,1,252.231,103.4a.2.2,0,0,0-.191-.029l-9.245,3.317a.207.207,0,0,1-.265-.265l3.654-10.2a.2.2,0,0,0-.009-.157,20.878,20.878,0,1,1,39.574-9.295Z"
          transform="translate(802 469)"
          fill="none"
          stroke="#37acbb"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_20"
          data-name="Path 20"
          d="M251.655,117.664a11.129,11.129,0,0,0,6.311,18.887.2.2,0,0,1,.154.113l2.121,4.507a.208.208,0,0,0,.375,0l2.363-5a.2.2,0,0,1,.118-.1,11.129,11.129,0,1,0-11.442-18.4Z"
          transform="translate(802 469)"
          fill="none"
          stroke="#37acbb"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_21"
          data-name="Path 21"
          d="M293.082,98.86a5.552,5.552,0,0,0-5.552,5.516,1.22,1.22,0,0,0,2.44,0,3.112,3.112,0,1,1,3.112,3.123,1.221,1.221,0,0,0-1.22,1.221v2.025a1.22,1.22,0,0,0,2.44,0v-.9a5.552,5.552,0,0,0-1.22-10.982"
          transform="translate(802 469)"
          fill="#37acbb"
        />
        <path
          id="Path_22"
          data-name="Path 22"
          d="M264.882,77.969a5.552,5.552,0,0,0-5.552,5.54,1.22,1.22,0,0,0,2.44,0,3.112,3.112,0,1,1,3.112,3.148,1.22,1.22,0,0,0-1.22,1.22V89.9a1.22,1.22,0,1,0,2.44,0v-.94a5.552,5.552,0,0,0-1.22-10.982Z"
          transform="translate(802 469)"
          fill="#37acbb"
        />
        <path
          id="Path_23"
          data-name="Path 23"
          d="M264.016,93.527a1.222,1.222,0,1,0,.007-.007l-.007.007"
          transform="translate(802 469)"
          fill="#37acbb"
        />
        <path
          id="Path_24"
          data-name="Path 24"
          d="M293.949,114.393a1.221,1.221,0,0,0-1.726-.007l-.007.007a1.1,1.1,0,0,0-.256.4,1.209,1.209,0,0,0-.1.463,1.221,1.221,0,1,0,2.441,0,1.016,1.016,0,0,0-.1-.463,1.7,1.7,0,0,0-.256-.4"
          transform="translate(802 469)"
          fill="#37acbb"
        />
        <path
          id="Path_25"
          data-name="Path 25"
          d="M262.418,122.3h-5.809a1.22,1.22,0,1,0,0,2.44h5.809a1.22,1.22,0,1,0,0-2.44"
          transform="translate(802 469)"
          fill="#37acbb"
        />
        <path
          id="Path_26"
          data-name="Path 26"
          d="M259.465,127.3h-2.856a1.22,1.22,0,0,0,0,2.44h2.856a1.22,1.22,0,1,0,0-2.44"
          transform="translate(802 469)"
          fill="#37acbb"
        />
      </g>
    </svg>
  );
};

export const iconHands = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 133.676 133.329"
    >
      <g
        id="Group_2"
        data-name="Group 2"
        transform="translate(-893.392 -468.89)"
      >
        <line
          id="Line_1"
          data-name="Line 1"
          x1="20.948"
          y1="21.183"
          transform="translate(1004.706 543.51)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_1"
          data-name="Path 1"
          d="M159.089,103.587c.782.7,1.563,1.485,2.345,2.267l24.7,25.951"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M115.317,73.572a27.758,27.758,0,0,1-3.752,4.846L92.805,95.693"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M193.17,84.358a8.361,8.361,0,0,0,.859-.86L218.1,58.563A8.624,8.624,0,0,0,205.676,46.6m0,0,.625-.625m-.625.625,4.534-4.69a8.624,8.624,0,1,0-12.429-11.959l-3.2,3.361,6.1-6.332a8.624,8.624,0,0,0-12.428-11.959l-5.393,5.628L185.2,18.23A8.624,8.624,0,0,0,172.768,6.271"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M132.279,131.725l24.388-25.951a46.342,46.342,0,0,1,20.557-12.35A38.611,38.611,0,0,0,185.9,89.75"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_5"
          data-name="Path 5"
          d="M118.6,31.831A8.624,8.624,0,0,0,106.172,43.79l14.3,14.852A8.624,8.624,0,0,0,132.9,46.682"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_6"
          data-name="Path 6"
          d="M135.093,24.093,128.136,16.9a8.624,8.624,0,1,0-12.428,11.959l17.353,17.978A8.624,8.624,0,1,0,145.489,34.88l-4.065-4.221"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          d="M145.489,34.879A8.624,8.624,0,0,0,157.917,22.92l-.938-1.016"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_8"
          data-name="Path 8"
          d="M147.365,11.977l-3.83-3.908a8.624,8.624,0,1,0-12.428,11.959"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_9"
          data-name="Path 9"
          d="M110.783,48.559A8.624,8.624,0,0,0,98.355,60.518l9.927,10.318A8.624,8.624,0,1,0,120.71,58.877"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          id="Path_10"
          data-name="Path 10"
          d="M172.846,6.115,163,1.5a5.357,5.357,0,0,0-6.018,1.016L144.316,15.026a3.376,3.376,0,0,0,0,4.846,10.711,10.711,0,0,0,15.32,0c5.941-6.175,13.288-13.757,13.288-13.757Z"
          transform="translate(802 469)"
          fill="none"
          stroke="#5a3622"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
      </g>
    </svg>
  );
};
